module.exports = __webpack_public_path__ + "static/img/8-8.4824b958.jpg";